export default __webpack_public_path__ + "assets/json/394eafe097d01c85a63836c7d80f548e.json";